import jQuery from 'jquery';
import React from 'react';
import '../libs/parallax';
import './Parallax.css';

export default class Parallax extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.pageLoaded) {
            jQuery(this.element)
                .css({
                    'background-repeat': 'no-repeat',
                    'background-attachment': 'fixed',
                    'background-size': '100% auto',
                    overflow: 'hidden',
                })
                .parallax({
                    imageSrc: '/images/bg-home7.jpg',
                    speed: 0.1,
                });
            return true;
        }
        return false;
    }

    render() {
        return (
            <div
                className="section"
                style={{
                    paddingTop: '120px',
                    paddingBottom: '120px',
                    position: 'relative',
                }}
            >
                <div
                    className="parallax"
                    ref={(el) => (this.element = el)}
                ></div>
                <div className="parallax-overlay"></div>
                <div className="container" style={{ position: 'relative' }}>
                    <div className="text-center">
                        <h1
                            className="fittext wite-text uppercase tlt"
                            style={{ fontSize: '33px' }}
                        >
                            VOUS GÉREZ UN GROUPE D’IMAGERIE MÉDICALE ET VOUS
                            RENCONTREZ DES PROBLÉMATIQUES SPÉCIFIQUES ? FRAPPE
                            DE COMPTES-RENDUS, AUDIT DE VOTRE ORGANISATION,
                            OPTIMISATION DE VOS INTERFACES MÉTIER RIS ET PACS :
                            PARTOUT EN FRANCE, STAPMEDIF VOUS ACCOMPAGNE.
                        </h1>
                        <div
                            className="hr1"
                            style={{ marginBottom: '32px' }}
                        ></div>
                    </div>
                </div>
            </div>
        );
    }
}

Parallax.propTypes = {};



// WEBPACK FOOTER //
// ./src/components/Parallax.jsx